import React from "react";
import { Card, CardBody } from "reactstrap";
import { Skeleton } from "antd";

const ProjectSkeleton = () => {
  const skeletonCard = (
    <Card
      style={{
        flex: "1 1 calc(25% - 16px)",
        maxWidth: "calc(25% - 16px)",
        minWidth: "250px",
        marginBottom: "12px",
        marginTop: "15px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
      }}
    >
      <CardBody
        style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          padding: "12px 16px", // Reduced padding
        }}
      >
        <Skeleton.Avatar shape="circle" size={48} />
        <div style={{ flex: 1 }}>
          <Skeleton height={10} width={`70%`} style={{ borderRadius: "4px" }} />
        </div>
      </CardBody>
    </Card>
  );

  const skeletonTabs = (
    <div style={{ marginTop: "24px" }}>
      <Skeleton active title={false} paragraph={{ rows: 10, width: "100%" }} />
    </div>
  );

  return (
    <div className="container-fluid p-5">
      <div
        style={{
          display: "flex",
          gap: "16px",
          flexWrap: "wrap",
          justifyContent: "flex-start",
          marginBottom: "24px",
        }}
      >
        {Array.from({ length: 4 }).map((_, index) => (
          <React.Fragment key={index}>{skeletonCard}</React.Fragment>
        ))}
      </div>
      {skeletonTabs}
    </div>
  );
};

export default ProjectSkeleton;
